import React, { useCallback, useMemo, useState } from 'react';
import _ from 'lodash';
import '@patternfly/react-core/dist/styles/base.css';
import LinkResource from './LinkResource';
import { SortDirection } from '../../Common/SimpleTable/SimpleTable';
import { NodeType } from 'utils/types';
import useDashboardsQuery from 'components/Dashboard/useDashboardsQuery';
import MultiLabelGroup from 'components/Common/MultiLabelGroup/MultiLabelGroup';
import { sortLocale } from 'utils/string';

const columns = [
  {
    label: '',
    path: 'displayName',
    isSortable: true,
    searchItem: true
  },
  {
    label: '',
    path: 'models',
    searchItem: true,
    render: (models) => {
      const labels = sortLocale((models ?? []).map((model) => ({ label: model })), 'label');
      return <MultiLabelGroup labels={labels} />;
    }
  }
];

const DefaultSortBy = {
  path: 'displayName',
  direction: SortDirection.DESC
};

const createDashboardEdges = (dashboards, parent) => {
  return dashboards.map((dashboard) => {
    return {
      fromId: parent.id,
      fromType: parent.type,
      toType: 'dashboard',
      toId: dashboard.id,
      relation: 'CONTAINS'
    };
  });
};


const LinkDashboard = ({ parentItem, onLinkDashboards, disableLink, isLinking }) => {
  const [hasError, setError] = useState(false);
  const dashboardsQuery = useDashboardsQuery({
    onError: useCallback((error) => {
      console.error('Failed to load dashboard collection. ', error);
      setError(true);
    }, [])
  });

  const dashboards = useMemo(() => {
    if (!dashboardsQuery.data) {
      return [];
    }
    if (!parentItem?.children) {
      return dashboardsQuery.data;
    }
    return dashboardsQuery.data.filter((dashboard) => {
      return !parentItem?.children.some((child) => {
        return child.id === dashboard.id;
      });
    });
  }, [dashboardsQuery.data, parentItem?.children]);

  const _onLinkDashboards = (selectedResources) => {
    const edges = createDashboardEdges(selectedResources, parentItem);
    // FIXME: need to support multi link
    onLinkDashboards(_.first(edges));
  };

  return (
    <>
      <LinkResource
        parentItem={parentItem}
        onLinkResources={_onLinkDashboards}
        data={dashboards}
        isLoading={dashboardsQuery.isFetching}
        isLinking={isLinking}
        hasError={hasError}
        columns={columns}
        defaultSortBy={DefaultSortBy}
        disableLink={disableLink || parentItem.type === NodeType.Dashboard}
      />
    </>
  );
};

export default LinkDashboard;
